import { ChangeEventHandler, FocusEventHandler, memo } from 'react';
import classNames from 'classnames';

import { ReactComponent as SearchIcon } from 'assets/images/search.svg';

import styles from './styles.module.scss';

type Props = {
  name: string;
  placeholder: string;
  value: string | number;
  type?: 'text' | 'number' | 'password' | 'email';
  className?: string;
  searchInput?: boolean;
  label?: string;
  error?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler;
};

export const Input: React.FC<Props> = memo(function Input({
  name,
  className,
  label,
  error,
  searchInput = false,
  type = 'text',
  ...restInputProps
}) {
  return (
    <div className={classNames(styles.container, className)}>
      {label && <label htmlFor={name}>{label}</label>}
      <input
        type={type}
        name={name}
        className={classNames({ [styles.error_input]: Boolean(error) })}
        {...restInputProps}
      />
      {error && <p>{error}</p>}
      {searchInput && (
        <div>
          <SearchIcon />
        </div>
      )}
    </div>
  );
});
